<template>
  <!-- 证书 -->
  <!-- ApplyForAJob和IndividualEdit都等于1时 正常显示求职意向 若有一条不等于1说明用户点击了添加或单条编辑 这时就要展示编辑栏 -->
  <div :class="IndividualEdit == 1 ? 'normal' : 'editor'">
    <div class="Title-Add-box">
      <div class="Title-Add" @click="handelClickEDITOR"></div>
      <p class="Title-p" @click="handelClickEDITOR">添加证书</p>
    </div>
    <!-- 正常展示证书数据 -->
    <div v-if="IndividualEdit == 1" class="NormalDisplay">
      <!-- 无证书数据展示待添加 -->
      <div class="None firm-clickable" v-if="data.length == 0" @click="handelClickEDITOR">
        待添加
      </div>
      <div
        class="normal-show"
        v-else
        v-for="(item, index) in data"
        :key="index"
      >
        <div class="top-threeRows">
          <p>{{ item.name }}</p>
          <p>证书编号：{{ item.code }}</p>
          <div class="already publicStyle" v-if="item.authentication == 1">
            已认证
          </div>
          <div class="alsoNot publicStyle" v-else>未认证</div>
          <div class="icon firm-clickable" @click="handelClickSingle(item, index)"></div>
        </div>
      </div>
    </div>
    <!-- 展示编辑栏 -->
    <div v-if="IndividualEdit == 2" class="StartEditing">
      <div class="EDITOR-top">
        <div class="EDITOR-required">
          <div class="required-title-p">
            <p v-for="(item, index) in titleArr" :key="index">
              <span v-if="item.Required == '1'" style="color: red">*</span>
              {{ item.name }}：
            </p>
          </div>
          <div class="required-ipt">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <!-- 证书名称 -->
              <div class="input-place">
                <el-form-item prop="name">
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="请输入证书名称"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 证书编号 -->
              <div class="input-place">
                <el-form-item prop="code">
                  <el-input
                    v-model="ruleForm.code"
                    placeholder="请输入证书编号"
                  ></el-input>
                </el-form-item>
                <!-- <el-input
                  v-model="ruleForm.code"
                  placeholder="请输入证书编号"
                ></el-input> -->
              </div>
            </el-form>
          </div>
          <div class="required-dele">
            <div class="firm-clickable" @click="handelDele" v-if="ApplyForAJob != '1'"></div>
          </div>
        </div>
      </div>
      <div class="EDITOR-btm">
        <p class="Cancel" @click="handelUnEdit">取消</p>
        <p class="verify" @click="handelSubmitEdit('ruleForm')">确认</p>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import {
  addUserCertificate, // 添加
  editUserCertificate, //编辑
  deleteUserCertificate, // 删除
} from "../../../../../../assets/api/CenterJane";
// 封装的表单验证
import { vxRule } from "../../../../../../../untils/FormValidation/validate-form";
export default {
  // 接收父组件传递的数据
  props: {
    data: {},
  },
  data() {
    return {
      IndividualEdit: 1, // 点击单个编辑
      titleArr: [{ name: "证书名称", Required: "1" }, { name: "证书编号" }], // 编辑栏input框右侧标题

      ruleForm: {
        name: "", // 证书名称
        code: "", // 证书编号
      }, // v-mode
      rules: {
        name: vxRule(true, "", ["blur", "change"], "请输入证书名称"),
        code: vxRule(true, "", ["blur", "change"], "请输入证书编号"),
      }, // 表单验证
      ApplyForAJob: "", // 为1时说明是在添加新的求职意向
      index: "", // 点击编辑时获取值，知道编辑的是哪一个
    };
  },
  components: {},
  methods: {
    // 添加
    handelClickEDITOR() {
      this.IndividualEdit = "2";
      this.ruleForm = {
        name: "", // 证书名称
        code: "", // 证书编号
      }; // v-mode

      this.ApplyForAJob = "1"; // 判断是编辑框还是添加框 空为编辑
    },
    // 点击编辑单条数据
    handelClickSingle(item, index) {
      this.index = item.id; // 获取要编辑的数据位置
      let newArr1 = JSON.parse(JSON.stringify(item));
      this.ruleForm = newArr1;
      this.IndividualEdit = 2;
      this.ApplyForAJob = ""; // 判断是编辑框还是添加框 空为编辑
    },
    // 点击清除
    handelDele() {
      this.$confirmWithScroll("是否删除本条信息?", "提示").then(() => {
        var data = {
          data: {
            userId: this.$store.getters.getUser.id,
            id: this.index,
          },
        };
        deleteUserCertificate(data).then((res) => {
          if (res.code == 0) {
            this.IndividualEdit = 1;
            this.ApplyForAJob = "";
            this.index = "";
            this.$emit("handelSubmitEdit");
            this.$tool.PromptBox("success", "修改成功");
          }
        });
      }).catch(() => {});
    },
    // 取消编辑
    handelUnEdit() {
      this.$emit("handelUnEdit", 7);
      this.IndividualEdit = 1;
    },
    // 编辑提交
    handelSubmitEdit(formName) {
      // 表单校验
      //if (valid) 校验成功 调接口继续下一步
      //else 校验失败  return false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.name.length <= 15) {
            if (this.ApplyForAJob == "") {
              // this.ApplyForAJob == ""时为编辑在原来的数据上修改
              var data = {};
              this.ruleForm.id = this.index;
              this.ruleForm.userId = this.$store.getters.getUser.id;
              data.data = this.ruleForm;
              // 调用接口修改简历个人信息
              editUserCertificate(data).then((res) => {
                if (res.code == 0) {
                  this.IndividualEdit = 1;
                  this.ApplyForAJob = "";
                  this.index = "";
                  this.$emit("handelSubmitEdit");
                  // 成功
                  this.$tool.PromptBox("success", "修改成功");
                  // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
                } else {
                  // 失败
                  // this.$tool.PromptBox("error", res.msg);
                }
              });
            } else {
              // 为添加，在原来的数据前新增一条
              var data = {};
              this.ruleForm.userId = this.$store.getters.getUser.id;
              data.data = this.ruleForm;
              // 调用接口修改简历个人信息
              addUserCertificate(data).then((res) => {
                if (res.code == 0) {
                  this.IndividualEdit = 1;
                  this.ApplyForAJob = "";
                  this.index = "";
                  this.$emit("handelSubmitEdit");
                  // 成功
                  this.$tool.PromptBox("success", "修改成功");
                  // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
                } else {
                  // 失败
                  // this.$tool.PromptBox("error", res.msg);
                }
              });
            }
          } else {
            this.$tool.PromptBox("warning", "请输入15字以内的证书名称");
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-form-item {
  width: 100%;
  margin-bottom: 0px;
  height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}
// input 框内的icon
/deep/.el-input__icon {
  font-size: 20px !important;
  margin-top: -3px;
}
// 修改 el组件库 input框的样式
/deep/.el-input__inner {
  width: 360px;
  width: 100% !important;
  height: 35px;
  border: 1px solid #409eff ;
  //   border-radius: 5px;
  //   border-right: none;
}
/deep/.el-textarea {
  min-height: 80px !important;
}
// 正常展示 大div
.normal {
  width: 100%;
  min-height: 25px;
  position: relative;
  border: 1px solid transparent;
}
// 编辑栏大div
.editor {
  width: 100%;
  min-height: 25px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
  position: relative;
}
// 添加icon样式
.Title-Add-box {
  display: flex;
  position: absolute;
  font-size: 12px;
  top: -45px;
  left: 90px;
}
.Title-Add {
  width: 18px;
  height: 18px;
  background-image: url("../../../../../../assets/imgs/tianjia@2x.svg");
  background-size: 100% 100%;
  margin: auto 0;
  margin-left: 30px;
  margin-right: 5px;
}

// 正常展示
.NormalDisplay {
  width: 100%;
  display: flex;
  flex-direction: column;
  // 无数据
  .None {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px dashed #409eff ;
    border-radius: 5px;
    font-size: 12px;
    color: #333333;
    font-weight: 400;
  }
  .normal-show:nth-child(1) {
    margin-top: 0px;
  }
  // 有数据正常展示
  .normal-show {
    width: 900px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    overflow-wrap: break-word;
    margin-top: 20px;
    .top-threeRows:nth-child(1) {
      margin-top: 0px;
    }
    .top-threeRows {
      width: 100%;
      height: 25px;
      line-height: 25px;
      margin-top: 15px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      display: flex;
      .publicStyle {
        width: 45px;
        height: 20px;
        margin: auto 0;
        text-align: center;
        line-height: 20px;
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        font-weight: 400;
        margin-right: 30px;
      }
      .already {
        background: rgba(97, 144, 232, 0.7);
        color: #ffffff;
      }
      .alsoNot {
        background: #eeeeee;
        color: #333333;
      }
      p {
        margin-right: 20px;
      }
      .CompanyName {
        font-size: 16px;
      }
      .icon {
        width: 18px;
        height: 18px;
        margin: auto 0;
        background-image: url("../../../../../../assets/imgs/bianji@3x.svg");
        background-size: 100% 100%;
      }
    }
  }
}
// 开始编辑
.StartEditing {
  flex: 1;
  margin: 30px 20px 20px 50px;
  display: flex;
  flex-direction: column;
  .EDITOR-top {
    width: 100%;
    margin-bottom: 20px;
    .EDITOR-required {
      width: 100%;
      min-height: 30px;
      display: flex;
      .required-title-p {
        min-width: 50px;
        text-align: right;
        p {
          height: 35px;
          line-height: 35px;
          margin-bottom: 25px;
          font-size: 14px;
          color: #333333;
          font-weight: 400;
        }
      }
      .required-ipt {
        width: 350px;

        .input-place {
          width: 100%;
          height: 35px;
          margin-top: 25px;
          display: flex;
          position: relative;
          .to-p {
            width: 60px;
            text-align: center;
            font-size: 14px;
            line-height: 35px;
          }
        }
        .input-place:nth-child(1) {
          margin-top: 0;
        }
      }
      .required-dele {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        div {
          width: 20px;
          height: 20px;
          background-image: url("../../../../../../assets/imgs/shanchu@3x.svg");
          background-size: 100% 100%;
        }
      }
    }
    .EDITOR-Description {
      width: 100%;
      min-height: 30px;
      p {
        flex: 1;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        margin-bottom: 5px;
      }
    }
  }
  // 编辑栏 下方按钮样式
  .EDITOR-btm {
    width: 100%;
    height: 40px;
    // margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .Cancel {
      box-sizing: border-box;
      border: 1px solid #999999;
      color: #333333;
      margin-right: 20px;
      cursor: pointer;
    }
    .verify {
      background: #409eff ;
      color: #ffffff;
      cursor: pointer;
    }
    p {
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
